import React, { useEffect, useMemo, useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { makeStyles } from "../../utils/styles/makeStyles";
import { find } from "lodash";
import COLOR from "utils/constants/color"

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "25px",
    width: "300px",
  },
  rootDif: {
    width: "200px",
  },
  rootDifFull: {
    width: "100%",
  },
  sizeSmall: {
    width: "55px",
    height: "25px",
  },
  checkedSwitch: {
    transform: "translateX(30px) !important",
  },
  label: {
    textTransform: "uppercase",
  },
  colorPrimary: {
    color: `${COLOR.green}!important`,
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
    minWidth: 120,
  },
  formControlStudent: {
    backgroundColor: "#fff",
    maxWidth: "250px",
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
}));

const MultiSelector = ({
  options,
  onSelect,
  selectedUser,
  titleName,
  selectTitle,
}) => {
  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const isAllSelected = useMemo(
    () => options && options.length > 0 && selected.length === options.length,
    [options, selected]
  );

  const handleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(
        selected.length === options.length ? [] : options.map((k) => k.id)
      );
      onSelect(
        selected.length === options.length ? [] : options.map((k) => k.id)
      );
      return;
    }
    onSelect(value);
    setSelected(value);
  };

  useEffect(() => {
    if (selectedUser.length === 0) {
      const userIds = options?.map((element) => element.id) || [];
      setSelected(userIds);
      onSelect(userIds);
    } else {
      setSelected(selectedUser);
      onSelect(selectedUser);
    }
  }, [selectedUser]);

  return (
    <FormControl className={classes.formControlStudent}>
      <Select
        multiple
        value={selected || []}
        onChange={handleChange}
        renderValue={(selected) => (
          <div className={classes.chips}>
            {`${
              isAllSelected || selected.length == 0
                ? `All ${selectTitle}`
                : `${selectTitle} (${selected.length})`
            }`}
          </div>
        )}
        MenuProps={MenuProps}
      >
        {options?.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            <Checkbox checked={Boolean(find(selected, (k) => k === item.id))} />
            <ListItemText primary={item?.displayName} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

// Export both names for backward compatibility
export { MultiSelector as MultiSelecter };
export default MultiSelector;
